import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ErrorMessagePipe } from '@app/shared/error-message.pipe';
import { Calendar, CircleAlert, LucideAngularModule } from 'lucide-angular';
import { NgxMaskDirective } from 'ngx-mask';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-text-input',
  imports: [FormsModule, ReactiveFormsModule, ErrorMessagePipe, LucideAngularModule, NgxMaskDirective, NgClass],
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.css',
  standalone: true,
})
export class TextInputComponent implements OnInit {
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() control!: FormControl;
  @Input() mask: string = '';
  @Input() thousandSeparator: string = '';
  @Input() prefix: string = '';

  constructor() {}

  ngOnInit(): void {}

  protected readonly Object = Object;
  protected readonly Validators = Validators;
  protected readonly Calendar = Calendar;
  protected readonly CircleAlert = CircleAlert;
}
